import { TableSchema } from '../metadata-schema';
import { Niveau } from '../enums/Niveau';

export const dim_ilt_opleidingscode: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_ilt_opleidingscode",
	"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"ilt_abb_profiel": {
			"type": "string",
			"label": "Profiel",
			"category": "Opleiding",
			"example": "NT, ZW, EM, ...",
			"description": "De afkorting van het profiel dat is gekoppeld aan de opleiding waarop de leerling is ingeschreven.\nDit is alleen van toepassing op de bovenbouw van het VMBO, HAVO of VWO."
		},
		"ilt_co_ilt": {
			"type": "integer",
			"label": "Opleidingscode",
			"category": "Opleiding",
			"example": "0011 - 7965",
			"searchKeys": [
				"ILT-code",
				"elementcode"
			],
			"description": "De officiële viercijferige code van de opleiding waarop de leerling is ingeschreven.\nDeze code werd vroeger ook wel aangeduid als ILT-code of elementcode."
		},
		"ilt_co_niveau": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ilt_des_opleiding": {
			"type": "string",
			"label": "Opleiding omschrijving",
			"category": "Opleiding",
			"example": "Leerjaar Voorbereidend op VMBO Theoretische/Gemengde Leerweg, HAVO Profiel Natuur en Techniek, ...",
			"description": "De volledige formele naam van de opleiding waarop de leerling is ingeschreven, inclusief leerweg en profiel, voor zover van toepassing."
		},
		"ilt_is_internationaal": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ilt_is_leerwerktraject": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "LWT",
			"category": "Kenmerk",
			"searchKeys": [
				"Leer-werktraject",
				"leerwerktraject"
			],
			"example": "Ja, Nee",
			"description": "Ja als de leerling is ingeschreven op een leerwerktraject in het VMBO basisberoepsgerichte leerweg."
		},
		"ilt_is_lwoo": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "LWOO",
			"category": "Kenmerk",
			"searchKeys": [
				"Leerwegondersteund onderwijs"
			],
			"example": "Ja, Nee",
			"description": "Ja als de leerling is ingeschreven op een VMBO-opleiding met leerwegondersteunend onderwijs."
		},
		"ilt_is_vakmanschap": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ilt_is_vavo": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "VAVO",
			"category": "Kenmerk",
			"example": "Ja, Nee",
			"description": "Ja als de leerling is ingeschreven op een VAVO-opleiding. \nVAVO-leerlingen zijn ingeschreven op een VAVO-opleiding op de eigen instelling, maar volgen extern onderwijs op een VAVO-school en doen daar examen."
		},
		"ilt_nm_leerweg": {
			"type": "string",
			"label": "Leerweg",
			"category": "Opleiding",
			"example": "BL, KL, GL, TL, HAV, VWO, ...",
			"description": "De afkorting van de leerweg van de officiële opleiding waarop de leerling is ingeschreven, zoals vermeld in de opleidingscode-tabel die is aangeleverd door DUO.\nVoor het VMBO is dit BL, KL, GL of TL voor respectievelijk de basis- en kader beroepsgerichte, gemengde en theoretische leerweg.\nDe entree-opleiding van de basisberoepsgerichte leerweg (voorheen assistentopleiding) is vermeld als AO.\nHet leerwerktraject binnen de basisberoepsgerichte leerweg is vermeld als LT.\nBinnen het VWO worden ATH, GYM, LYC en VWO gebruikt voor respectievelijk atheneum, gymnasium, lyceum en ongedeeld VWO."
		},
		"ilt_nm_niveau": {
			"label": "Niveau",
			"category": "Opleiding",
			"example": "VMBO b, PrO, HAVO / VWO, ...",
			"description": "Het niveau van de officiële opleiding waarop de leerling is ingeschreven.\nNiveaus kunnen met elkaar worden vergeleken om te bepalen of leerlingen op- of afstromen, of worden vergeleken met het basisschooladvies.\nIn het VMBO worden de verschillende leerwegen behandeld als afzonderlijke niveaus, met uitzondering van de gemengde en theoretische leerweg die het gezamenlijke niveau \"VMBO (g)t\" hebben.\nAtheneum en Gymnasium vormen samen het niveau VWO.\nDe brede combinatieniveaus in de onderbouw zijn verzameld in het niveau OND. Dit niveau kan niet worden vergeleken met andere niveaus.",
			"type": "string",
			"schema": Niveau
		},
		"ilt_nm_niveau_ob": {
			"label": "Niveau onderbouw",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Het niveau van de officiële opleiding waarop de leerling is ingeschreven.\nDeze is gelijk aan Niveau, behalve voor de niveau waarde OND, daar staat dan een specifiekere waarde.",
			"type": "string",
			"schema": Niveau
		},
		"ilt_nm_opleiding": {
			"type": "string",
			"label": "Opleiding (officieel)",
			"category": "Opleiding",
			"example": "vmbo-gl/tl/havo voorbereid. lj, havo natuur/techniek, ...",
			"description": "De formele naam van deze opleiding, inclusief leerweg en profiel, voor zover van toepassing."
		},
		"ilt_nm_profiel": {
			"type": "string",
			"label": "Profielomschrijving",
			"category": "Opleiding",
			"example": "Zorg en Welzijn, Economie en maatschappij, ...",
			"description": "Het profiel dat is gekoppeld aan de opleiding waarop de leerling is ingeschreven.\nDit is alleen van toepassing op de bovenbouw van het VMBO, HAVO of VWO."
		},
		"ilt_nr_examenjaar": {
			"type": "integer",
			"minimum": 0,
			"maximum": 6,
			"label": "Opleiding examenjaar",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
